import React from "react";
const BackgroundAnimation=()=>
{
    return (
        <>
        <div id='stars'></div>
        <div id='stars2'></div>
        <div id='stars3'></div>
        </>
    );
}
export default BackgroundAnimation;